import { render, staticRenderFns } from "./AssessmentExam.vue?vue&type=template&id=5c25ee5f&"
import script from "./AssessmentExam.vue?vue&type=script&lang=js&"
export * from "./AssessmentExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports